export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-MSSQL.cc973dc9.png";